import React from 'react';
import { Button } from '@mui/material';
import FileDownloadOutlined from '@mui/icons-material/FileDownloadOutlined';
import * as XLSX from 'xlsx';

// Define getSummaryLabel within ExportExcel
const getSummaryLabel = (shortLabel) => {
  switch (shortLabel) {
    case 'P': return 'Present';
    case 'A': return 'Absent';
    case 'H': return 'Holidays';
    case 'L': return 'Leave';
    case 'Work': return 'Work Days';
    case 'Non-Work': return 'Non-Work';
    default: return shortLabel;
  }
};

const ExportExcel = ({ attendanceDetails, schoolName, fromDate, toDate, isStudent, allDatesInRange, summaryColumns }) => {
  const handleExport = () => {
    if (!attendanceDetails?.length) return;

    // Prepare data for export
    const exportData = attendanceDetails.map(detail => {
      const row = {
        Employee: detail.employeeName?.trim() || `ID: ${detail.employeeId}`,
      };
      // Add summary columns
      summaryColumns.forEach(col => {
        row[getSummaryLabel(col.label)] = detail[col.key] ?? 0;
      });
      // Add daily attendance
      allDatesInRange.forEach(dateObj => {
        const dateKey = `${dateObj.getFullYear()}-${(dateObj.getMonth() + 1).toString().padStart(2, '0')}-${dateObj.getDate().toString().padStart(2, '0')}`;
        row[dateObj.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' })] = detail.dailyAttendance?.[dateKey] || 'A';
      });
      return row;
    });

    // Create worksheet
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Attendance');

    // Export file
    XLSX.writeFile(wb, `Employee_Attendance_${fromDate}_to_${toDate}.xlsx`);
  };

  return (
    <Button
      variant="outlined"
      size="medium"
      startIcon={<FileDownloadOutlined />}
      onClick={handleExport}
      disabled={!attendanceDetails?.length}
      sx={{ height: 40 }}
    >
      Export
    </Button>
  );
};

export default ExportExcel;